module.exports = __webpack_public_path__ + "img/Oryza_sativa_Japonica_Group.76a4e65b.jpg";